import React from "react";

const Container: React.FC<{
    children: React.ReactNode;
    direction?: "row" | "column";
    className?:string
}> = ({
    children,
    direction = "column",
    className
}) => {
    const selctDirection = {
        row: "flex-row",
        column: "flex-col",
    }
    return (
        <div className={` flex ${selctDirection[direction]} ${className}`}>
            {children}
        </div>
    )
};
export default Container